













































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Form as ElForm, Select as ElSelect } from 'element-ui'
import { isPhone, isPassword } from '@/utils/validate'
import { add, update, details } from '@/api/account'
import { getSupplierSelectList } from '@/api/common'
import { InitModule } from '@/store/modules/init'

interface DetailsResponse {
  phone: string
  username: string
  password: string
  shops: string
  warehouses: string
  adminType: number
  supplierId?: string
}

interface SupplierItem {
  supplierName: string
  supplierId: string
}

@Component({
  name: 'OperationModal'
})
export default class extends Vue {
  @Prop({ default: false }) operationDialogFlag!: boolean
  @Prop() id!: number
  private visible = false
  private formParams = {
    username: '',
    phone: '',
    password: '',
    warehouses: [],
    shops: [],
    adminType: 0,
    supplierId: ''
  }

  private supplierList: SupplierItem[] = []

  private validatePhone = (rule: any, value: string, callback: Function) => {
    if (!isPhone(value)) {
      callback(new Error('请输入正确的手机号码'))
    } else {
      callback()
    }
  }

  private validatePassword = (rule: any, value: string, callback: Function) => {
    if (this.id) {
      if (value && !isPassword(value)) {
        callback(new Error('8~16位数字和英文组成'))
      } else {
        callback()
      }
    } else {
      if (!isPassword(value)) {
        callback(new Error('8~16位数字和英文组成'))
      } else {
        callback()
      }
    }
  }

  private rules = {
    username: [{ required: true, message: '请输入姓名', trigger: 'change' }],
    adminType: [{ required: true, message: '请选择账号类型', trigger: 'change' }],
    phone: [{ required: true, validator: this.validatePhone, trigger: 'change' }],
    password: [{ required: true, validator: this.validatePassword, trigger: 'change' }],
    warehouses: [{ required: true, type: 'array', message: '请选择仓库', trigger: 'change' }],
    shops: [{ required: true, type: 'array', message: '请选择店铺', trigger: 'change' }],
    supplierId: [{ required: false, message: '请选择供应商', trigger: 'change' }]
  }

  get shopList() {
    return InitModule.shopList
  }

  get warehouseList() {
    return InitModule.warehouseList
  }

  // 获取供应商列表
  private async loadSupplierList() {
    try {
      const { content } = await getSupplierSelectList<SupplierItem[]>()
      this.supplierList = content || []
    } catch (error) {
      console.error('获取供应商列表失败:', error)
      this.supplierList = []
    }
  }

  // 账号类型变更处理
  private onAdminTypeChange(value: number) {
    if (value === 1) {
      // 合作商账号，加载供应商列表
      this.loadSupplierList()
      // 设置供应商为必填
      this.rules.supplierId = [{ required: true, message: '请选择供应商', trigger: 'change' }]
    } else {
      // 集团账号，清空供应商选择并设为非必填
      this.formParams.supplierId = ''
      this.rules.supplierId = [{ required: false, message: '请选择供应商', trigger: 'change' }]
    }
  }

  private warehouseSelect(list: number[]) {
    if (list.includes(1000)) {
      (this.formParams.warehouses as number[]) = [1000];
      (this.$refs.warehouses as ElSelect).blur()
    }
  }

  private shopSelect(list: number[]) {
    if (list.includes(0)) {
      (this.formParams.shops as number[]) = [0];
      (this.$refs.shop as ElSelect).blur()
    }
  }

  private close() {
    this.$emit('update:operationDialogFlag', false);
    (this.$refs.form as ElForm).resetFields()
  }

  private onSubmit() {
    (this.$refs.form as ElForm).validate(async(valid: boolean) => {
      if (valid) {
        const params = { ...this.formParams, shops: JSON.stringify(this.formParams.shops), warehouses: JSON.stringify(this.formParams.warehouses) }
        this.id ? await update({ ...params, id: this.id }) : await add(params)
        this.id ? this.$message.success('修改成功') : this.$message.success('新增成功')
        this.$emit('onsubmit')
        this.close()
      }
    })
  }

  @Watch('operationDialogFlag')
  async handQualityDialogFlag() {
    this.visible = this.operationDialogFlag
    if (this.visible && this.id) {
      // 数据回填
      if (this.id) {
        const { content } = await details<DetailsResponse>({ id: this.id })
        const { username, phone, shops, warehouses, adminType, supplierId } = content
        this.rules.password = [{ required: false, validator: this.validatePassword, trigger: 'change' }]
        this.formParams = { 
          username, 
          phone, 
          password: '', 
          shops: JSON.parse(shops), 
          warehouses: JSON.parse(warehouses), 
          adminType,
          supplierId: supplierId || ''
        }
        
        // 如果是合作商账号，加载供应商列表
        if (adminType === 1) {
          this.loadSupplierList()
          this.rules.supplierId = [{ required: true, message: '请选择供应商', trigger: 'change' }]
        }
      }
    } else {
      this.rules.password = [{ required: true, validator: this.validatePassword, trigger: 'change' }]
      // 重置供应商相关状态
      this.formParams.supplierId = ''
      this.rules.supplierId = [{ required: false, message: '请选择供应商', trigger: 'change' }]
    }
  }
}
